import styled, { css } from 'styled-components';

import { Box } from '@ovpn-ui/core';
import { breakPoints, media } from '@ovpn-ui/styles';

export const PageHeaderWrapper = styled.div`
    .ovpn-breadcrumbs {
        margin-bottom: 8px;

        ol {
            margin: 0;
            padding-left: 0;
        }

        li {
            display: inline-block;
            max-width: 100%;
            overflow: hidden;

            text-overflow: ellipsis;
        }
    }

    .ovpn-header-description {
        word-break: break-word;
    }
`;

const mobileStyles = css`
    flex-direction: column;
    align-items: flex-start;

    .header-actions {
        flex-direction: column;
        gap: var(--spacing-xs);
        width: 100%;

        & > button,
        & > a {
            width: 100%;
            margin-left: 0 !important;
        }

        .expandable-search {
            order: -1;
            margin-left: 0 !important;
        }
    }
`;

export const ResponsiveButtonGroup = styled(Box)`
    display: flex;
    gap: var(--spacing-xs);
    align-items: center;

    .ovpn-header {
        min-width: 0;

        &-title {
            max-width: 100%;
            overflow: hidden;

            white-space: nowrap;
            text-overflow: ellipsis;
        }
    }

    .header-actions {
        & > button,
        & > a {
            flex: 1 0 auto;
        }
    }

    ${media.moreThen(breakPoints.SM + 1)`
        .ovpn-header-title {
            line-height: 43px;
        }
    `}

    ${media.SM`${mobileStyles}`}
` as typeof Box;
